import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetClaims = (params, signal) => axios.get(apiPaths.claimsBase, { params, signal });

const onGetMapRisks = (params) => axios.get(`${apiPaths.claimsBase}/risk-map-points`, { params });

const onExportClaims = (claimsIds) =>
  axios.post(`${apiPaths.claimsBase}/create-export-file`, claimsIds, { responseType: 'arraybuffer' });

export { onGetClaims, onGetMapRisks, onExportClaims };
